module.exports = __webpack_public_path__ + "img/5.058b8893.png";